import React from 'react';

import useShowAfter from '../../helpers/useShowAfter';

/**
 * Wrapper genérico: renderiza `children` só depois de `delay` ms.
 *
 * <p>Uso principal: fallback de `<Suspense>`. Chunks pequenos carregam em
 * &lt;200ms — mostrar indicador nesses casos vira flicker (REDLINE-loading.md
 * §2). Wrapping o fallback com `<DelayedFallback>` esconde qualquer indicador
 * até o chunk atrasar de verdade.
 *
 * <p>Substitui o `<DelayedLoader/>` anterior — que era hardcoded pra Loader.
 * Aqui o child é livre (Loader pra bootstrap; PagedListSkeleton pra rotas de
 * listagem; PanelSkeleton/FormSkeleton pra outras — cada rota escolhe).
 *
 * <p>Exemplos:
 * ```jsx
 * <Suspense fallback={<DelayedFallback><Loader/></DelayedFallback>}>
 * <Suspense fallback={<DelayedFallback><PagedListSkeleton/></DelayedFallback>}>
 * ```
 */
export default function DelayedFallback({ delay = 200, children }) {
	const show = useShowAfter(delay);
	return show ? children : null;
}
